export const LOAD_CITY = "LOAD_CITY";
export const ADD_CITY = "ADD_CITY";
export const UPDATE_CITY = "UPDATE_CITY";
export const DELETE_CITY = "DELETE_CITY";
export const CLEAR_CITY = "CLEAR_CITY";
export const DEFAULT_CITY = "DEFAULT_CITY";
